import { Field, Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import { Button, Input, ModalBox, Textarea, useModalContext } from '@fourthwall/components';
import * as S from './CreateAppModal.styled';
const validationSchema = Yup.object().shape({
    name: Yup.string().required('App name is required'),
    description: Yup.string(),
});
const getInitialValues = () => ({
    name: '',
    description: '',
    redirectUris: [],
});
export const CreateAppModal = ({ onSave }) => {
    const { close } = useModalContext();
    const handleSubmit = (values) => {
        onSave(values.name, values.description, values.redirectUris);
        close();
    };
    const handleCancel = () => {
        close();
    };
    return (React.createElement(Formik, { initialValues: getInitialValues(), validationSchema: validationSchema, onSubmit: handleSubmit }, ({ isValid, dirty, submitForm }) => (React.createElement(Form, null,
        React.createElement(ModalBox, { title: "Create New App", onClose: handleCancel, buttons: [
                React.createElement(Button, { label: "Create", appearance: "primary", onClick: submitForm, disabled: !isValid || !dirty }),
            ] },
            React.createElement(S.Container, null,
                React.createElement(S.FieldsContainer, null,
                    React.createElement(Field, { component: Input, name: "name", label: "App Name", placeholder: "Enter app name" }),
                    React.createElement(Field, { component: Textarea, name: "description", label: "Description", placeholder: "Enter app description" }))))))));
};
